module.exports = {"610116001":"韦曲街道","610116002":"郭杜街道","610116003":"滦镇街道","610116004":"引镇街道","610116005":"王寺街道","610116006":"马王街道","610116007":"太乙宫街道","610116008":"东大街道","610116009":"子午街道","610116010":"斗门街道","610116011":"细柳街道","610116012":"杜曲街道","610116013":"大兆街道","610116014":"黄良街道","610116015":"兴隆街道","610116016":"王曲街道","610116017":"鸣犊街道","610116018":"王莽街道","610116019":"五台街道","610116020":"高桥街道","610116021":"五星街道","610116022":"灵沼街道","610116023":"杨庄街道","610116024":"砲里街道","610116025":"魏寨街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610116.json
// module id = 2784
// module chunks = 0